export default "__VITE_ASSET__KjFVd2jn__"